import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { saveRedirectUrl, isUserVotingPage } from '@/utils/redirect'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/dashboard',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/modules/auth/views/login-view.vue'),
    },
    {
      path: '/auth/login',
      name: 'auth-login',
      component: () => import('@/modules/auth/views/login-view.vue'),
    },
    {
      path: '/create-account',
      name: 'create-account',
      component: () => import('@/modules/auth/views/create-account-view.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/modules/dashboard/views/dashboard-view.vue'),
      meta: { useLayout: true, requiresAuth: true },
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/modules/dashboard/views/dashboard-view.vue'), // Dashboard shows projects
      meta: { useLayout: true, requiresAuth: true },
    },
    {
      path: '/templates',
      name: 'templates',
      component: () => import('@/modules/dashboard/views/dashboard-view.vue'), // Placeholder for now
      meta: { useLayout: true, requiresAuth: true },
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('@/modules/auth/components/change-password.vue'),
      meta: { useLayout: true, requiresAuth: true },
    },
  ],
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // Save redirect URL for user voting pages
    if (isUserVotingPage(to.fullPath)) {
      saveRedirectUrl(to.fullPath)
      console.log('🔄 Saving redirect URL for user voting page:', to.fullPath)
    }
    next('/login')
  } else if (to.name === 'login' && authStore.isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
